import { BooLogo } from "@/components/BooLogo";
import { Button } from "@/components/ui/button";
import { signOut } from "@/lib/auth-client";
import { LogOut } from "lucide-react";

// Standalone, centered waitlist screen — intentionally NOT wrapped in the
// onboarding layout (no step indicator, no right-hand preview). A waitlisted
// signup has nothing to set up yet, so the screen is just the message,
// centered on an otherwise empty page. Purely presentational; the polling +
// redirect-on-approval logic lives in the route wrapper.
export function WaitlistScreen() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 py-12">
      <div className="w-full max-w-sm flex flex-col items-center text-center gap-6">
        <div className="relative">
          <span
            className="boo-pulse absolute -inset-6 rounded-full"
            style={{
              background:
                "radial-gradient(closest-side, rgba(127, 119, 221, 0.4), transparent 70%)",
            }}
          />
          <BooLogo className="relative size-16 rounded-2xl" />
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl font-semibold">You're on the waitlist</h1>
          <p className="text-sm text-muted-foreground leading-relaxed">
            Thanks for signing up. We're onboarding new teams in batches and
            will email you as soon as your Boo is ready to set up.
          </p>
        </div>

        <p className="text-sm text-muted-foreground leading-relaxed">
          Already have a team on Boo? Ask a teammate to invite you — you'll get
          in right away, no waiting.
        </p>
      </div>

      <Button
        type="button"
        variant="ghost"
        size="sm"
        onClick={() =>
          signOut({ fetchOptions: { onSuccess: () => window.location.assign("/login") } })
        }
        className="fixed bottom-6 right-6 text-muted-foreground"
      >
        <LogOut />
        Log out
      </Button>
    </div>
  );
}
